// Generated by ReScript, PLEASE EDIT WITH CARE


var title = {
  id: "1dd11115-5c1e-4d39-9817-2ba5f3620a5b",
  defaultMessage: "Allocation and monitoring of POOL expenses"
};

var resultInfo = {
  id: "eebd34d3-093f-4f09-afbd-2916edc558a2",
  defaultMessage: "expenses"
};

var rmpcIpnLabel = {
  id: "6f6fe9d3-c6c8-43d7-9540-c315a8c75229",
  defaultMessage: "IPN RMPC"
};

var rmpcNameLabel = {
  id: "dc61da17-d415-4b3c-8cb5-7b1ce64e1de8",
  defaultMessage: "RMPC name"
};

var mrIpnLabel = {
  id: "c21c21d4-78b2-4fe0-8aa5-36b486c11d5b",
  defaultMessage: "IPN MR"
};

var mrNameLabel = {
  id: "720871d0-06a8-446c-a1e8-156536f7c58b",
  defaultMessage: "MR name"
};

var allocatedResources = {
  id: "af096604-0cd3-426b-a6e0-9b483c39eca7",
  defaultMessage: "Allocated expense"
};

var finishedRequestsAmount = {
  id: "5bfe1b17-0a69-4145-981d-d34882ca8326",
  defaultMessage: "Paid"
};

var remainingResources = {
  id: "67182968-c637-4923-91cc-56cd7ce64dcf",
  defaultMessage: "Remaining"
};

var unvalidatableRequestsAmount = {
  id: "1239f6bf-793f-4e7c-8e54-ec16637c84c1",
  defaultMessage: "Pending"
};

var validatableRequestsAmount = {
  id: "869646f6-576d-4de7-b346-96b9aef46e97",
  defaultMessage: "To be paid"
};

var expensesRMPC = {
  id: "ff593ced-0256-4c8b-8e39-b947a5986b62",
  defaultMessage: "RMPC expenses"
};

var expensesMR = {
  id: "b67d985f-98f7-48ad-9aee-122c1f694b76",
  defaultMessage: "MR expenses"
};

var modifyPoolExpense = {
  id: "a43e9d05-4a4a-4735-9b4f-b5e5adc653fc",
  defaultMessage: "Modify a POOL Budget"
};

var amountToAdd = {
  id: "c864f089-7fa8-4e76-880a-62e24acaf6d4",
  defaultMessage: "Amount to add"
};

var q1Period = {
  id: "f30095fd-6438-4a96-b242-a4f7add0afd1",
  defaultMessage: "JFM (January - February - March)"
};

var q2Period = {
  id: "7ea66d65-459e-455a-85e7-8869b63d4f58",
  defaultMessage: "AMJ (April - May - June)"
};

var q3Period = {
  id: "f55f62e2-0b38-4c39-be41-81a6b227a4aa",
  defaultMessage: "JAS (July - August - September)"
};

var q4Period = {
  id: "64372a4f-6b94-4c10-8225-8c0febbdeb79",
  defaultMessage: "OND (October - November - December)"
};

var availableExpenses = {
  id: "e67ed8f5-59d4-4da5-8778-ed575b95df8d",
  defaultMessage: "Available expenses"
};

var requestsToBeValidated = {
  id: "ed8d0ead-6e4e-4cb5-85ea-027de4aa1a34",
  defaultMessage: "Bonus requests need to be validated"
};

var allocationsToBeChecked = {
  id: "090909fe-a3f3-4169-a32c-4cd77e5dce49",
  defaultMessage: "Please review your budget allocation"
};

var allocatedResourcesChanged = {
  id: "920157d5-02a4-4c3d-8028-d8d53514a4e3",
  defaultMessage: "Your budget for the period {period} has been modified. Please review your budget allocation"
};

var existingMrAssigned = {
  id: "25e4b753-2427-4487-9c44-1019ab9dc710",
  defaultMessage: "An existing MR ({mr}) has been assigned to you. Please review your budget allocation"
};

var newMrAssigned = {
  id: "789a2221-b884-46a0-a962-3baed52f79aa",
  defaultMessage: "A new MR ({mr}) has been assigned to you. Please review your budget allocation"
};

var mrDisassigned = {
  id: "289d6e26-8951-4237-997a-02a28991da86",
  defaultMessage: "An MR ({mr}) has been unassigned from you. Please review your budget allocation"
};

var dprAllocationReminder = {
  id: "42c94abc-09ba-40df-a2dc-f7b800005a6a",
  defaultMessage: "Veuillez penser à affecter ce budget au RMPC du MR"
};

var rmpcNotEnoughResourcesWarning = {
  id: "5607916c-52b0-4e9e-8ba0-22a3a8c11d5c",
  defaultMessage: "Le budget qui vous a été alloué est épuisé. Vous n'avez plus la possibilité d'affecter un budget supplémentaire pour cette période"
};

export {
  title ,
  resultInfo ,
  rmpcIpnLabel ,
  rmpcNameLabel ,
  mrIpnLabel ,
  mrNameLabel ,
  allocatedResources ,
  finishedRequestsAmount ,
  remainingResources ,
  unvalidatableRequestsAmount ,
  validatableRequestsAmount ,
  expensesRMPC ,
  expensesMR ,
  modifyPoolExpense ,
  amountToAdd ,
  q1Period ,
  q2Period ,
  q3Period ,
  q4Period ,
  availableExpenses ,
  requestsToBeValidated ,
  allocationsToBeChecked ,
  allocatedResourcesChanged ,
  existingMrAssigned ,
  newMrAssigned ,
  mrDisassigned ,
  dprAllocationReminder ,
  rmpcNotEnoughResourcesWarning ,
}
/* No side effect */
